export const FETCH_VERIFIED = "[MIS] FETCH_VERIFIED";
export const FETCH_VERIFIED_START = "[MIS] FETCH_VERIFIED_START";
export const FETCH_VERIFIED_SUCCESS = "[MIS] FETCH_VERIFIED_SUCCESS";
export const FETCH_VERIFIED_ERROR = "[MIS] FETCH_VERIFIED_ERROR";

export const UNDO_REPORT_FROM_HOLD_QUEUE = "[MIS] UNDO_REPORT_FROM_HOLD_QUEUE";
export const UNDO_REPORT_FROM_HOLD_QUEUE_START = "[MIS] UNDO_REPORT_FROM_HOLD_QUEUE_START";
export const UNDO_REPORT_FROM_HOLD_QUEUE_SUCCESS = "[MIS] UNDO_REPORT_FROM_HOLD_QUEUE_SUCCESS";
export const UNDO_REPORT_FROM_HOLD_QUEUE_ERROR = "[MIS] UNDO_REPORT_FROM_HOLD_QUEUE_ERROR";

export const SET_VERIFIED_PAGINATION = "[MIS] SET_VERIFIED_PAGINATION";
export const SET_VERIFIED_FILTER = "[MIS] SET_VERIFIED_FILTER";

export const VIEW_VERIFIED_VISIT_LOADING_START = "[MIS] VIEW_VERIFIED_VISIT_LOADING_START";
export const VIEW_VERIFIED_VISIT_LOADING_END = "[MIS] VIEW_VERIFIED_VISIT_LOADING_END";
export const RESET_VERIFIED_FILTER = "[MIS] RESET_VERIFIED_FILTER";

export const SET_VERIFIED_ALL_CASES_FILTER = "[MIS] SET_VERIFIED_ALL_CASES_FILTER";

export const fetchMisVerified = (payload) => {
    return {
        type: FETCH_VERIFIED,
        payload
    };
};

export const setMisVerifiedFilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_VERIFIED_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const undoReportFromHoldQueue = (reportId) => {
    return {
        type: UNDO_REPORT_FROM_HOLD_QUEUE,
        payload: {
            reportId
        }
    };
};

export const resetVerifiedFilter = () => {
    return {
        type: RESET_VERIFIED_FILTER
    }
}

export const setVerifiedAllCasesfilter = (myCasesOnly) => {
    return {
        type: SET_VERIFIED_ALL_CASES_FILTER,
        payload: {
            myCasesOnly
        }
    };
}